import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Participants from "./views/Participants";
import Login from "./views/Login";
import store from './store'
import Participant from "./views/Participant";
import Categories from "./views/Categories";
import Checkpoints from "./views/Checkpoints";
import Category from "./views/Category";
import CheckpointParticipant from "./views/CheckpointParticipant";
import CheckpointPublic from "./views/CheckpointPublic";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/participants',
      name: 'participants',
      component: Participants,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/categories',
      name: 'categories',
      component: Categories,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/categories/:id',
      name: 'category',
      props: true,
      component: Category,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/checkpoints',
      name: 'checkpoints',
      component: Checkpoints,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/checkpoints/:token',
      name: 'checkpoints-participants',
      props: true,
      component: CheckpointParticipant,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/checkpoint',
      name: 'checkpoint-public-login',
      component: CheckpointPublic,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/checkpoint/:token',
      name: 'checkpoint-public',
      component: CheckpointPublic,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/participants/:id',
      component: Participant,
      name: 'participant',
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/participants/:id/checkin',
      component: Participant,
      name: 'participantCheckIn',
      props: true,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/')
  } else if (store.getters.isLoggedIn && to.matched.some(record => record.name === 'login')) {
    next('/home')
  } else {
    next()
  }
})

export default router
